export const affichage = (state) => state.affichage;
export const paramsRob = (state) => state.paramsRob;
export const breadCrumbs = (state) => state.breadCrumbs;
